module.exports = __webpack_public_path__ + "assets/img/19.3d7f62ed.png";